var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    fill: "#fe4d01",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126 31.5L72 81L18 31.5H126Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 27H18a4.5 4.5 0 0 0-4.5 4.5V108a9 9 0 0 0 9 9h99a9 9 0 0 0 9-9V31.5A4.5 4.5 0 0 0 126 27zM72 74.897L29.571 36h84.858L72 74.897zM55.524 72L22.5 102.268V41.732L55.524 72zm6.66 6.103l6.75 6.216a4.5 4.5 0 0 0 6.086 0l6.75-6.216L114.396 108H29.571l32.614-29.897zM88.476 72L121.5 41.726v60.548L88.476 72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.8dc5461c3279d4882eb7e0f3a2e96b00.svg";
export { ForwardRef as ReactComponent };